module.exports = __webpack_public_path__ + "img/lonxun-logo-01-en.f3405b89.png";